<template>
  <li ref="anchor" class="nav-item" :data-tour-id="tourId">
    <router-link class="nav-link" :to="to">
      <span class="sidenav-mini-icon">{{ miniIcon }}</span>
      <span class="sidenav-normal">{{ text }}</span>
    </router-link>
  </li>
</template>

<script>
export default {
  name: "SidenavItem",
  props: {
    to: {
      type: [Object, String],
      required: false,
    },
    miniIcon: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    tourId: {
      type: String,
      default: null
    }
  },
  methods: {
    getAnchor() {
      return this.$refs.anchor;
    }
  }
};
</script>
